













































































import { Component, Vue } from "vue-property-decorator";
import { readEntries } from "@/store/uniabc/getters";
import Entry from "@/interfaces/uniabc/Entry";
import Renderer from "@/utils/Renderer";
import { Language } from "@/interfaces/uniabc/Language";
import AddEntry from "@/components/editor/AddEntry.vue";
import DateUtils from "@/utils/DateUtils";
import { dispatchDeleteEntry } from "@/store/uniabc/actions";

@Component({
  components: { AddEntry }
})
export default class ListEntries extends Vue {
  private headers = [
    { text: "Info", value: "info" },
    { text: "Label", value: "label" },
    { text: "Term", value: "term_de" },
    { text: "Section", value: "section" },
    { text: "Last Edit", value: "lastEdit" },
    { text: "Last Approval", value: "lastApprovalDate" },
    { text: "Actions", value: "edit" },
    { text: "", value: "data-table-expand" }
  ];

  private entries = readEntries(this.$store);
  private entrySearch = "";
  private expanded = [];
  private updateEntr = 0;

  private translationThreshold = 50;

  private filterNoTranslation = false;

  get entriesList() {
    this.updateEntr;
    let entries = Object.keys(this.entries).map((e: string) => this.entries[e]);

    if (this.filterNoTranslation) {
      entries = entries.filter(this.translationRateNotify);
    }

    return entries;
  }

  private renderText(entry: Entry) {
    return Renderer.renderedText(entry, Language.DE);
  }

  private deleteEntry(entry: Entry) {
    dispatchDeleteEntry(this.$store, entry);
    this.updateEntr++;
  }

  private toShortDateStr(date: Date) {
    return DateUtils.getShortDateTimeString(new Date(date));
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sortByDate(items: any[], index: any, isDesc: boolean[]) {
    items.sort((a, b) => {
      if (index[0] == "lastApprovalDate") {
        if (!isDesc[0]) {
          return (
            new Date(a.lastApproved.date).getTime() -
            new Date(b.lastApproved.data).getTime()
          );
        } else {
          return (
            new Date(b.lastApproved.date).getTime() -
            new Date(a.lastApproved.date).getTime()
          );
        }
      } else if (index[0] == "lastEdit") {
        if (!isDesc[0]) {
          return (
            new Date(a.lastEdit).getTime() - new Date(b.lastEdit).getTime()
          );
        } else {
          return (
            new Date(b.lastEdit).getTime() - new Date(a.lastEdit).getTime()
          );
        }
      } else if (!isNaN(a[index[0]])) {
        if (!isDesc[0]) {
          return a[index[0]] - b[index[0]];
        } else {
          return b[index[0]] - a[index[0]];
        }
      } else {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
          } else {
            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
          }
        }
      }
    });
    return items;
  }

  private translationRateNotify(e: Entry) {
    return (
      e.text_en.length < (this.translationThreshold / 100) * e.text_de.length
    );
  }
}
